import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Plus } from 'lucide-react';
import { AnimatePresence } from 'framer-motion';
import { trackAddToCart } from '../../utils/metaPixel';
const reviews = [{
  text: 'I used the 15-minute rule yesterday and we actually made it to dinner without tears. I feel like I have my brain back.',
  name: 'Sarah M.'
}, {
  text: 'My son used to scream the second he walked in the door. After two days of the reset, he actually sat down and had a snack quietly. I almost cried.',
  name: 'Jessica T.'
}, {
  text: 'The calm scripts are EVERYTHING. I read them off my phone and it actually works. No more yelling from me either.',
  name: 'Amanda R.'
}, {
  text: "I finally understand why 4PM was so hard. It's not me. It's not him. It's the overload. That shift alone changed everything.",
  name: 'Danielle K.'
}, {
  text: 'We went from daily meltdowns to maybe one a week. And when they happen, I know exactly what to do. Game changer.',
  name: 'Rachel P.'
}, {
  text: "The decompression checklist saved us. I didn't realize I was accidentally triggering him the second he got home.",
  name: 'Megan L.'
}, {
  text: "I have three kids and was skeptical anything 'simple' would work. But the 30-minute reset is genuinely doable, even with chaos.",
  name: 'Christina B.'
}, {
  text: 'My daughter has ADHD and this is the first thing that actually meets her where she is. No shame, just support.',
  name: 'Lauren W.'
}, {
  text: 'I stopped dreading pickup. That sentence alone would have been worth 10x the price. Thank you.',
  name: 'Katie H.'
}];
export function OfferSection() {
  const [currentReview, setCurrentReview] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentReview(prev => (prev + 1) % reviews.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <section id="purchase" className="py-24 px-4 md:px-6 bg-white relative overflow-hidden" data-id="element-139">
      <div className="max-w-5xl mx-auto" data-id="element-140">
        <div className="text-center mb-16" data-id="element-141">
          <h2 className="text-4xl md:text-5xl font-bold text-sage-dark mb-4" data-id="element-142">
            Everything you need to reset your evenings
          </h2>
          <p className="text-xl text-sage-dark/70" data-id="element-143">
            Simple, practical, and ready to use tonight.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-8 items-start" data-id="element-144">
          {/* Main Offer Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-7 bg-cream-100 rounded-3xl p-8 md:p-10 border-2 border-sage-light/30 shadow-xl relative" data-id="element-145">
            <div className="absolute top-0 right-0 bg-terracotta text-white text-xs font-bold px-4 py-2 rounded-bl-xl rounded-tr-xl uppercase tracking-wider" data-id="element-146">
              Most Popular
            </div>

            <h3 className="text-3xl font-bold text-sage-dark mb-2 font-serif" data-id="element-147">
              Tantrum-Free After-School Evenings
            </h3>
            <p className="text-sage-dark/60 mb-8 font-medium" data-id="element-148">
              The Complete Ebook Guide
            </p>

            <div className="space-y-6 mb-10" data-id="element-149">
              <div className="flex items-start gap-4" data-id="element-150">
                <div className="w-6 h-6 rounded-full bg-sage-dark text-white flex items-center justify-center flex-shrink-0 mt-1" data-id="element-151">
                  <Check size={14} data-id="element-152" />
                </div>
                <div data-id="element-153">
                  <strong className="block text-sage-dark text-lg" data-id="element-154">
                    The exact 4PM reset + routines + scripts
                  </strong>
                  <p className="text-sage-dark/70" data-id="element-155">
                    Step-by-step guide to transforming the chaos.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-156">
                <div className="w-6 h-6 rounded-full bg-sage-dark text-white flex items-center justify-center flex-shrink-0 mt-1" data-id="element-157">
                  <Check size={14} data-id="element-158" />
                </div>
                <div data-id="element-159">
                  <strong className="block text-sage-dark text-lg" data-id="element-160">
                    Quick-start "Try This Tonight" page
                  </strong>
                  <p className="text-sage-dark/70" data-id="element-161">
                    So you can act immediately, not "someday".
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-162">
                <div className="w-6 h-6 rounded-full bg-sage-dark text-white flex items-center justify-center flex-shrink-0 mt-1" data-id="element-163">
                  <Check size={14} data-id="element-164" />
                </div>
                <div data-id="element-165">
                  <strong className="block text-sage-dark text-lg" data-id="element-166">
                    Decompression checklist
                  </strong>
                  <p className="text-sage-dark/70" data-id="element-167">
                    Prevents accidental triggers in the first 15 minutes.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl border border-sage-light/20 mb-8 relative overflow-hidden min-h-[120px]" data-id="element-168">
              <div className="flex items-center gap-2 mb-3" data-id="element-169">
                <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" data-id="element-170" />
                <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" data-id="element-171" />
                <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" data-id="element-172" />
                <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" data-id="element-173" />
                <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" data-id="element-174" />
              </div>
              <AnimatePresence mode="wait" data-id="element-175">
                <motion.div key={currentReview} initial={{
                opacity: 0,
                y: 12
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -12
              }} transition={{
                duration: 0.45,
                ease: 'easeInOut'
              }} data-id="element-176">
                  <p className="text-sage-dark italic leading-relaxed" data-id="element-177">
                    "{reviews[currentReview].text}"
                  </p>
                  <p className="text-sage-dark/50 text-sm mt-2 font-medium not-italic" data-id="element-178">
                    — {reviews[currentReview].name}
                  </p>
                </motion.div>
              </AnimatePresence>
              {/* Progress dots */}
              <div className="flex items-center justify-center gap-1.5 mt-4" data-id="element-179">
                {reviews.map((_, i) => <div key={i} className={`w-1.5 h-1.5 rounded-full transition-all duration-300 ${i === currentReview ? 'bg-terracotta w-4' : 'bg-sage-light/50'}`} data-id="element-180" />)}
              </div>
            </div>

            <div className="text-center mb-6" data-id="element-181">
              <span className="inline-block bg-terracotta/90 text-white text-sm font-bold px-3 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-182">
                🔥 76% OFF — Limited Time
              </span>
              <div className="flex items-center justify-center gap-3" data-id="element-183">
                <span className="text-sage-dark/40 line-through text-xl" data-id="element-184">
                  $27
                </span>
                <span className="text-4xl font-bold text-sage-dark" data-id="element-185">$6.39</span>
              </div>
            </div>

            <a href="https://www.gemmamama.com/cart/45458351751307:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="block w-full py-4 bg-terracotta text-white font-bold rounded-xl text-lg hover:bg-terracotta-hover transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all text-center" data-id="element-186">
              Get the Guide — $6.39
            </a>
          </motion.div>

          {/* Add-ons Column */}
          <div className="lg:col-span-5 space-y-6" data-id="element-187">
            <div className="p-4 bg-gray-50 rounded-xl text-center" data-id="element-188">
              <p className="text-xs text-gray-500" data-id="element-189">
                Secure checkout. Instant digital delivery.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}